import React from 'react';
import './AlertModal.css';

export default function AlertModal({ show, type, title, message, onConfirm, onCancel, confirmText = 'OK', cancelText = 'Cancel' }) {
  // Add stack trace to see which component instance is rendering
  const stackTrace = new Error().stack;
  const isAppJs = stackTrace.includes('App.js');
  const componentName = isAppJs ? '[AlertModal-App.js]' : '[AlertModal-Other]';
  
  console.log(`${componentName} Rendering with props:`, { show, type, title, message: message?.substring(0, 50) + '...' });
  console.log(`${componentName} Stack trace:`, stackTrace.split('\n').slice(1, 3).join('\n'));
  
  if (!show) {
    console.log(`${componentName} Not showing because show is false`);
    return null;
  }

  console.log(`${componentName} Rendering modal component`);
  return (
    <div className="alert-modal-overlay" onClick={onCancel}>
      <div className="alert-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="alert-modal-header">
          <h3 className="alert-modal-title">{title || (type === 'confirm' ? 'Confirm' : 'Alert')}</h3>
        </div>
        <div className="alert-modal-body">
          <p className="alert-modal-message">{message}</p>
        </div>
        <div className="alert-modal-footer">
          {type === 'confirm' ? (
            <>
              <button
                className="alert-modal-btn alert-modal-btn-cancel"
                onClick={onCancel}
              >
                {cancelText}
              </button>
              <button
                className="alert-modal-btn alert-modal-btn-confirm"
                onClick={onConfirm}
              >
                {confirmText}
              </button>
            </>
          ) : (
            <button
              className="alert-modal-btn alert-modal-btn-confirm"
              onClick={onConfirm || onCancel}
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

